module.exports = __webpack_public_path__ + "img/file-plus-alt.4eea36d5.svg";